import { render } from "./MemberListOverlayCancerforum.vue?vue&type=template&id=4de9f5dc"
import script from "./MemberListOverlayCancerforum.vue?vue&type=script&lang=js"
export * from "./MemberListOverlayCancerforum.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__